<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <pi-progress v-if="progress"></pi-progress>
      <v-card-title class="headline">{{headline}}</v-card-title>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="accent" flat @click="$emit('closed')">Odrzuć</v-btn>
        <v-btn v-if="!hideOperation" color="error" flat @click="$emit('action')">{{operation}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "headline", "operation", "progress", "hideOperation"],
  data: () => ({})
};
</script>